/* assets/wishlist.js */
(() => {
  const KEY = 'theme:wishlist:v1';
  const MAX = 100;

  const read = () => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  };
  const write = (list) => {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {}
  };

  const Wishlist = {
    all: read,
    has: (h) => read().includes(h),
    toggle(handle) {
      const list = read();
      const i = list.indexOf(handle);
      i > -1 ? list.splice(i, 1) : list.unshift(handle);
      write(list);
      document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { handle, list, added: i === -1 } }));
      return i === -1;
    },
  };
  window.Wishlist = Wishlist;

  /* ---- UI sync: buttons + header counter ---- */
  function sync(root = document) {
    const list = read();
    root.querySelectorAll('[data-wishlist-toggle]').forEach((btn) => {
      const on = list.includes(btn.dataset.wishlistToggle);
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on);
    });
    document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
      el.textContent = list.length;
      el.hidden = list.length === 0;
    });
  }

  /* One delegated listener: works for product cards, PDP, cart drawer, quick view, AJAX-loaded grids */
  document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-wishlist-toggle]');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation(); // card is usually wrapped in a link
  Wishlist.toggle(btn.dataset.wishlistToggle);

  // shake animation
  btn.classList.remove('is-shaking');
  void btn.offsetWidth; // force reflow so the animation restarts on rapid clicks
  btn.classList.add('is-shaking');
  btn.addEventListener('animationend', () => btn.classList.remove('is-shaking'), { once: true });
});

  document.addEventListener('wishlist:change', () => sync());
  window.addEventListener('storage', (e) => { if (e.key === KEY) sync(); }); // cross-tab

  /* Re-sync when the theme injects new markup (drawer cart, infinite scroll, filters) */
  let t;
  new MutationObserver(() => { clearTimeout(t); t = setTimeout(() => sync(), 50); })
    .observe(document.body, { childList: true, subtree: true });

  /* ---- Wishlist page ---- */
  async function renderPage() {
    const grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    const empty = document.querySelector('[data-wishlist-empty]');
    const list = read();
    empty && (empty.hidden = list.length > 0);
    grid.innerHTML = '';
    // Fetch the theme's own card markup through an alternate product template
    const cards = await Promise.all(list.map((h) =>
      fetch(`/products/${encodeURIComponent(h)}?view=wishlist-card`)
        .then((r) => (r.ok ? r.text() : ''))
        .catch(() => '')
    ));
    grid.innerHTML = cards.join('');
    sync(grid);
  }
  document.addEventListener('wishlist:change', (e) => {
    // On the wishlist page, removing an item removes its card
    if (!e.detail.added) {
      document.querySelectorAll(`[data-wishlist-grid] [data-product-handle="${e.detail.handle}"]`).forEach((n) => n.remove());
      const empty = document.querySelector('[data-wishlist-empty]');
      if (empty) empty.hidden = e.detail.list.length > 0;
    }
  });

  document.addEventListener('DOMContentLoaded', () => { sync(); renderPage(); });
})();
